






























import {Component, Mixins} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import SelectDialogField from '@c/controls/selectControls/SelectDialogField.vue';
import DtcpAccelerometerModuleMeasurementEditDialog from '@/views/system/modules/forms/dtcp/DtcpAccelerometerModuleMeasurementEditDialog.vue';
import {
  PModuleMeasurementTableHeader,
  PModuleTableHeader,
  PModuleWithMeasurements,
} from '@/views/system/modules/interfaces';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import {PModuleMeasurementStore} from '@/views/system/modules/forms/pModuleMeasurementStore';
import {updateMeasurements} from '@/views/system/modules/moduleUtils';
import TableCheckBox from './tables/TableCheckBox.vue';
import {AxiosPromise} from 'axios';
import {PModuleType} from '@/enums/configs';
import PModuleMeasurementEditDialog from '@/views/system/modules/forms/PModuleMeasurementEditDialog.vue';

@Component({
  components: {
    EditDialog,
    SelectDialogField,
    TableCheckBox,
    DtcpAccelerometerModuleMeasurementEditDialog,
  },
})
export default class MeasurementDialog extends Mixins(EditDialogMixin) {
  pmodule: any = [];

  measurementDialogForm =
    this.pmodule.type == PModuleType.DtcpAccelerometerModule
      ? DtcpAccelerometerModuleMeasurementEditDialog
      : PModuleMeasurementEditDialog;

  type: any = null;

  mod: PModuleWithMeasurements | null = null;

  name = '';

  get headers() {
    if (this.pmodule.type == PModuleType.DtcpTemperatureModule) return this.measurementsTempHeaders;
    else return this.measurementsHeaders;
  }

  get getWidth() {
    if (this.pmodule.type == PModuleType.DtcpTemperatureModule) return '900px';
    else return '700px';
  }

  measurementsHeaders: PModuleTableHeader[] = [
    {
      text: 'Измерение',
      value: 'measurementDescription',
      sortable: false,
    },
    {
      text: 'В. гр. предупреждения',
      value: 'topWarningBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. опасного значения',
      value: 'topDangerBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. ошибки',
      value: 'topErrorBoundary',
      sortable: false,
    },
  ];

  measurementsTempHeaders: PModuleMeasurementTableHeader[] = [
    {
      text: 'Измерение',
      value: 'measurementDescription',
      sortable: false,
    },
    {
      text: 'В. гр. предупреждения',
      value: 'topWarningBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. опасного значения',
      value: 'topDangerBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. ошибки',
      value: 'topErrorBoundary',
      sortable: false,
    },
    {
      text: 'Н. гр. предупреждения',
      value: 'bottomWarningBoundary',
      sortable: false,
    },
    {
      text: 'Н. гр. опасного значения',
      value: 'bottomDangerBoundary',
      sortable: false,
    },
    {
      text: 'Н. гр. ошибки',
      value: 'bottomErrorBoundary',
      sortable: false,
    },
  ];

  get measurementsStore() {
    if (this.pmodule.type == PModuleType.DtcpTemperatureModule)
      return new PModuleMeasurementStore(this.pmodule, {
        'topWarningBoundary': true,
        'topDangerBoundary': true,
        'topErrorBoundary': true,
        'bottomWarningBoundary': true,
        'bottomDangerBoundary': true,
        'bottomErrorBoundary': true,
      });
    else return new PModuleMeasurementStore(this.pmodule);
  }

  async loadMeasurements() {
    // Подгружаем список измерений, ещё не использованных в таблице
    await measurementsStoreModule.fetchAll();
    if (this.pmodule.measurements) {
      //для тех измерений, которые уже сохранены, проставляем isActive = true и isNew = false
      this.pmodule.measurements.forEach((elem: any) => {
        if (!elem.isNew) {
          (elem.isActive = true), (elem.isNew = false);
        }
      });
      const entities = measurementsStoreModule.entities;
      const newEntities = entities.filter(
        (x: any) =>
          x.moduleType === this.pmodule.type &&
          !this.pmodule.measurements.some((y: any) => y.measurementId == x.id),
      );
      // если такие измерения найдены, добавляем их в таблицу измерений модуля
      if (newEntities.length > 0) {
        updateMeasurements(this.pmodule.measurements, newEntities);
      }
    }
  }

  async openDialog(data: any, type: any, options: any, source: any, request: AxiosPromise) {
    this.pmodule = data;
    this.type = type;

    await this.loadMeasurements();
    this.openAsync(request, source, options);
  }
}
